export const baseUrl = import.meta.env.VITE_DMW_BASE_URL || 'https://webapi.dev.bep-dm.com'
export const APP_NAME = 'Artemis'
export const helpDeskUrl = 'https://diningalliance.atlassian.net/servicedesk/customer/portal/8'

export const DEFAULT_CURRENCY = 'USD'

export const MONTH_LABELS_SHORT = [
	'Jan',
	'Feb',
	'Mar',
	'Apr',
	'May',
	'Jun',
	'Jul',
	'Aug',
	'Sep',
	'Oct',
	'Nov',
	'Dec',
]

export const STANDARD_ANNUAL_PERIOD_MONTHS = 12

export const bottomWhiteSpaceSmall = '6rem'
export const bottomWhiteSpace = '12rem'
export const tabListHeight = '4rem'

export const fontFamily = ['Roboto', 'sans-serif']
export const fontWeightLight = 300
export const fontWeightRegular = 400
/* When fontWeightMedium is below 550, the dataGrid will not display grid lines,
changed to 550 to correct. */
export const fontWeightMedium = 550
export const fontWeightBold = 700

export const announcementBannerHeight = '2.25rem'
export const appBarHeight = '0rem'
export const appBarHeightMobile = '3rem'
export const pageTitleHeight = '4rem'
export const pageHeaderHeight = '50px' // using pixels as there is a rendering issue when rems
export const tableToolbarHeight = '4rem'
